import { ED_REDESIGN_ENABLED } from 'features/ed-redesign/config';
import JourneyLayout from 'features/ed-redesign/JourneyLayout';
import { useLocation } from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import SimpleHeader from './simple-header';

export default function SimpleBaseAppLayout() {
  const { pathname } = useLocation();
  if (ED_REDESIGN_ENABLED && pathname.startsWith('/ed-treatment/')) return <JourneyLayout />;
  return (
    <div className="flex flex-col min-h-screen">
      <SimpleHeader />
      <main className="flex-grow px-4">
        <Outlet />
      </main>
    </div>
  );
}
